import React from "react";

import svg from "../../assets/images/icons/RichText/code.svg";

export const CodeIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Code"}
    />
);
